import React, { useEffect, useRef } from 'react'
import './SettingsRail.css'

interface SettingsRailProps {
  children: React.ReactNode
  onClose: () => void
  width?: number
  className?: string
}

/**
 * Standardized settings rail wrapper for Agent Studio.
 * Renders as a flex-shrink:0 column that pushes sibling content (canvas + chat)
 * to the left. No backdrop, no fixed positioning — pure inline layout.
 *
 * Provides: slide-in animation, ESC-to-close, border/shadow, overflow scroll.
 */
/** Every settings tab (State, Knowledge, Memory, ...) uses the same width so switching tabs never reflows. */
const SETTINGS_RAIL_WIDTH = 480

export function SettingsRail({ children, onClose, width: _legacyWidth, className }: SettingsRailProps) {
  const railRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [onClose])

  return (
    <div
      ref={railRef}
      className={`settings-rail ${className || ''}`}
      style={{ width: `${SETTINGS_RAIL_WIDTH}px` }}
    >
      {children}
    </div>
  )
}
